import { useEffect } from "react";
import { connectSocket, disconnectSocket, isSocketConnected } from "../../services/websocket";
const SocketProvider = ({ children }) => {
  useEffect(() => {
    if (!isSocketConnected()) {
      connectSocket();
    }

    return () => {
      disconnectSocket();
    };
  }, []);

  return children;
};

export default SocketProvider;
